export const addTransparentClassHeader = () => {
  const header = document.querySelector('[data-header]');

  header.classList.add('transparent')
}